import { useEffect, useState } from 'react';
import findActivePath from './findActivePath';

/**
 * React hook to find the active menu path in menuData
 * based on the current window.location.pathname.
 * @param {Object} menu - The menu structure object.
 * @returns {string[]} - Array of id strings representing the path to the active item.
 */
function useActiveMenuPath(menu) {
    const [activePath, setActivePath] = useState([]);

    useEffect(() => {
        setActivePath(findActivePath(menu, window.location.pathname));
    }, []);

    return activePath;
}

export default useActiveMenuPath;
